'use client'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { useBranding } from '@/components/branding-provider'
import { DEFAULT_BRANDING } from '@/lib/branding-defaults'

export type LogoVariant = 'white' | 'blackBg'

interface PrimodropLogoProps {
  className?: string
  height?: number
  href?: string | null
  /** Logo branca para fundos escuros (sidebar, login escuro) */
  variant?: LogoVariant
  /** @deprecated use variant="blackBg" */
  onDark?: boolean
  alt?: string
}

function resolveVariant(variant: LogoVariant | undefined, onDark: boolean): LogoVariant {
  if (variant) return variant
  return onDark ? 'blackBg' : 'white'
}

export function PrimodropLogo({
  className,
  height = 28,
  href = '/dashboard',
  variant,
  onDark = false,
  alt = 'Logo da plataforma',
}: PrimodropLogoProps) {
  const { logoWhite, logoBlackBg, loading } = useBranding()
  const resolved = resolveVariant(variant, onDark)

  if (resolved === 'blackBg') {
    if (!logoBlackBg) return null
  }

  const src = (resolved === 'blackBg'
    ? logoBlackBg
    : (logoWhite || DEFAULT_BRANDING.logoWhite)) as string

  const image = (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt={alt}
      className={cn('w-auto object-contain', loading && 'opacity-70', className)}
      style={{ height }}
    />
  )

  if (!href) return image

  return (
    <Link href={href} className="inline-flex shrink-0" aria-label="Ir para o dashboard">
      {image}
    </Link>
  )
}
